import { useCallback } from 'react';
import { useToast } from '../../../hooks/ui/useToast';
import { safeAnalytics } from '../../../utils/analytics';
import { ANALYTICS_EVENTS } from '../../../constants/analytics';

/**
 * What the chat says when the researcher opens another conversation, or starts
 * a new one, while Bower is still answering. Leaving aborts only this tab's
 * stream; the turn finishes server-side (docs/architecture/agent-service.md,
 * "A dropped stream never reaches a deployed turn"), so the answer is there on
 * return. Says nothing when no reply is streaming.
 */
export function useLeaveStreamingTurnNotice(isStreaming: boolean) {
  const toast = useToast();
  return useCallback(
    (destination: 'history' | 'new') => {
      if (!isStreaming) return;
      toast({
        title: 'Bower is still answering in the previous conversation.',
        description: 'It will be there when you go back.',
        status: 'info',
      });
      safeAnalytics.track(ANALYTICS_EVENTS.CHAT_LEFT_STREAMING_TURN, { destination });
    },
    [isStreaming, toast],
  );
}
